import type { EventName } from "@lit/react";
import { AppLayout as AppLayoutElement, type AppLayoutEventMap as _AppLayoutEventMap, } from "@vaadin/app-layout/vaadin-app-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { AppLayoutElement, };
export type AppLayoutEventMap = Readonly<{
    onPrimarySectionChanged: EventName<_AppLayoutEventMap["primary-section-changed"]>;
    onDrawerOpenedChanged: EventName<_AppLayoutEventMap["drawer-opened-changed"]>;
    onOverlayChanged: EventName<_AppLayoutEventMap["overlay-changed"]>;
}>;
const events = { onPrimarySectionChanged: "primary-section-changed", onDrawerOpenedChanged: "drawer-opened-changed", onOverlayChanged: "overlay-changed" } as AppLayoutEventMap;
export type AppLayoutProps = WebComponentProps<AppLayoutElement, AppLayoutEventMap>;
export const AppLayout = createComponent({
    elementClass: AppLayoutElement, events, react: React, tagName: "vaadin-app-layout"
});
